import {
  createElement,
  Volume2,
  VolumeX,
  Play,
  Square,
  Shuffle,
  Waves,
  Save,
  FolderOpen,
  Moon,
  Sun,
  Circle,
  Download,
  Lock,
  Unlock,
  Plus,
  X
} from 'lucide';

/**
 * Initialize all icons in the UI
 */
export function initIcons(): void {
  const iconAttrs = { 'stroke-width': 1.5, width: 16, height: 16 };
  const iconAttrsLg = { 'stroke-width': 1.5, width: 20, height: 20 };
  const iconAttrsSm = { 'stroke-width': 1.5, width: 12, height: 12 };
  const iconAttrsXl = { 'stroke-width': 1, width: 32, height: 32 };

  const shuffleEl = document.getElementById('icon-shuffle');
  if (shuffleEl) {
    shuffleEl.innerHTML = '';
    shuffleEl.appendChild(createElement(Shuffle, iconAttrs));
  }

  const playEl = document.getElementById('icon-play');
  if (playEl && playEl.children.length === 0) {
    playEl.appendChild(createElement(Play, iconAttrsLg));
  }

  const wavesEl = document.getElementById('icon-waves');
  if (wavesEl) {
    wavesEl.innerHTML = '';
    wavesEl.appendChild(createElement(Waves, iconAttrsXl));
  }

  // Preset buttons
  const saveEl = document.getElementById('icon-save');
  if (saveEl) {
    saveEl.innerHTML = '';
    saveEl.appendChild(createElement(Save, iconAttrsSm));
  }

  const folderEl = document.getElementById('icon-folder');
  if (folderEl) {
    folderEl.innerHTML = '';
    folderEl.appendChild(createElement(FolderOpen, iconAttrsSm));
  }

  // Sample section buttons
  const saveSampleEl = document.getElementById('icon-save-sample');
  if (saveSampleEl) {
    saveSampleEl.innerHTML = '';
    saveSampleEl.appendChild(createElement(Save, iconAttrsSm));
  }

  const libraryEl = document.getElementById('icon-library');
  if (libraryEl) {
    libraryEl.innerHTML = '';
    libraryEl.appendChild(createElement(FolderOpen, iconAttrsSm));
  }

  // Recording buttons
  const recordEl = document.getElementById('icon-record');
  if (recordEl && recordEl.children.length === 0) {
    recordEl.appendChild(createElement(Circle, iconAttrsSm));
  }

  const downloadEl = document.getElementById('icon-download');
  if (downloadEl) {
    downloadEl.innerHTML = '';
    downloadEl.appendChild(createElement(Download, iconAttrsSm));
  }

  // Lock button (only initialize if empty, updateLockIcon handles changes)
  const lockEl = document.getElementById('icon-lock');
  if (lockEl && lockEl.children.length === 0) {
    lockEl.appendChild(createElement(Unlock, iconAttrsSm));
  }

  // Add layer button
  const addLayerEl = document.getElementById('icon-add-layer');
  if (addLayerEl) {
    addLayerEl.innerHTML = '';
    addLayerEl.appendChild(createElement(Plus, iconAttrsSm));
  }

  // Close library button
  const closeLibraryEl = document.getElementById('icon-close-library');
  if (closeLibraryEl) {
    closeLibraryEl.innerHTML = '';
    closeLibraryEl.appendChild(createElement(X, iconAttrsSm));
  }

  // Initialize mute button icons (only if empty)
  document.querySelectorAll('.mute-icon').forEach((el) => {
    if (el.children.length === 0) {
      el.appendChild(createElement(Volume2, iconAttrsSm));
    }
  });

  // Initialize theme icon based on current theme (only if empty)
  const themeEl = document.getElementById('icon-theme');
  if (themeEl && themeEl.children.length === 0) {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    themeEl.appendChild(createElement(isDark ? Sun : Moon, iconAttrs));
  }
}

/**
 * Update play/pause icon
 */
export function updatePlayIcon(isPlaying: boolean): void {
  const playEl = document.getElementById('icon-play');
  const playBtn = document.getElementById('play-pause-btn');
  if (playEl && playBtn) {
    playEl.innerHTML = '';
    const iconAttrsLg = { 'stroke-width': 1.5, width: 20, height: 20 };
    playEl.appendChild(createElement(isPlaying ? Square : Play, iconAttrsLg));
    playBtn.classList.toggle('playing', isPlaying);
  }
}

/**
 * Update lock icon
 */
export function updateLockIcon(locked: boolean): void {
  const lockEl = document.getElementById('icon-lock');
  const lockBtn = document.getElementById('lock-btn');
  if (lockEl && lockBtn) {
    lockEl.innerHTML = '';
    const iconAttrsSm = { 'stroke-width': 1.5, width: 12, height: 12 };
    lockEl.appendChild(createElement(locked ? Lock : Unlock, iconAttrsSm));
    lockBtn.classList.toggle('locked', locked);
    lockBtn.title = locked ? 'Unlock patterns (allow evolution)' : 'Lock patterns (prevent changes during playback)';
  }

  // Also disable/enable the variation slider when locked
  const variationSlider = document.getElementById('variation-slider') as HTMLInputElement;
  if (variationSlider) {
    variationSlider.disabled = locked;
  }
}

/**
 * Update mute icon by layer ID
 */
export function updateMuteIconById(layerId: string, muted: boolean): void {
  const iconEl = document.querySelector(`.mute-icon[data-layer-id="${layerId}"]`);
  const btn = document.querySelector(`.mute-btn[data-layer-id="${layerId}"]`);
  if (iconEl && btn) {
    iconEl.innerHTML = '';
    const iconAttrsSm = { 'stroke-width': 1.5, width: 12, height: 12 };
    iconEl.appendChild(createElement(muted ? VolumeX : Volume2, iconAttrsSm));
    btn.classList.toggle('muted', muted);
  }
}
